//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchFilter from '~/mixins/search/search-filter'

export default {
  name: 'FilterCheckbox',
  mixins: [searchFilter]
}
